// extracted by mini-css-extract-plugin
module.exports = {"Slot":"Slot_Slot__a1fdY","Dropable":"Slot_Dropable__K4ci6","NotDropable":"Slot_NotDropable__4Lt6v"};